var _path, _rect, _path2, _path3, _rect2, _path4, _path5, _rect3, _path6, _path7, _rect4, _path8, _path9, _rect5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatItCanDoHm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 528,
    viewBox: "0 0 1280 528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.46 278C237.042 278 233.46 274.418 233.46 270C233.46 265.582 237.042 262 241.46 262L233.46 262L233.46 278L241.46 278Z",
    fill: "#22E06C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.46,
    y: 278,
    width: 16,
    height: 16,
    transform: "rotate(180 233.46 278)",
    fill: "#22E06C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.46 278C213.878 278 217.46 274.418 217.46 270C217.46 265.582 213.878 262 209.46 262L217.46 262L217.46 278L209.46 278Z",
    fill: "#22E06C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.46 278C1206.04 278 1202.46 274.418 1202.46 270C1202.46 265.582 1206.04 262 1210.46 262L1202.46 262L1202.46 278L1210.46 278Z",
    fill: "#22E06C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.46,
    y: 278,
    width: 16,
    height: 16,
    transform: "rotate(180 1202.46 278)",
    fill: "#22E06C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.46 278C1182.88 278 1186.46 274.418 1186.46 270C1186.46 265.582 1182.88 262 1178.46 262L1186.46 262L1186.46 278L1178.46 278Z",
    fill: "#22E06C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632 419L632 411L640 411L648 411L648 419C648 414.582 644.418 411 640 411C635.582 411 632 414.582 632 419Z",
    fill: "#22E06C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 411,
    width: 16,
    height: 16,
    transform: "rotate(-90 632 411)",
    fill: "#22E06C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632 387L632 395L640 395L648 395L648 387C648 391.418 644.418 395 640 395C635.582 395 632 391.418 632 387Z",
    fill: "#22E06C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168 486C168 481.582 171.582 478 176 478C180.418 478 184 481.582 184 486L184 478L168 478L168 486Z",
    fill: "#22E06C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 478,
    width: 16,
    height: 16,
    transform: "rotate(-90 168 478)",
    fill: "#22E06C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168 454C168 458.418 171.582 462 176 462C180.418 462 184 458.418 184 454L184 462L168 462L168 454Z",
    fill: "#22E06C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1096 352C1096 347.582 1099.58 344 1104 344C1108.42 344 1112 347.582 1112 352L1112 344L1096 344L1096 352Z",
    fill: "#22E06C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1096,
    y: 344,
    width: 16,
    height: 16,
    transform: "rotate(-90 1096 344)",
    fill: "#22E06C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1096 320C1096 324.418 1099.58 328 1104 328C1108.42 328 1112 324.418 1112 320L1112 328L1096 328L1096 320Z",
    fill: "#22E06C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 512V294C0 285.163 7.16345 278 16 278H147H432C440.837 278 448 285.163 448 294V379C448 387.837 440.837 395 432 395H192C178.745 395 168 405.745 168 419V512C168 520.837 160.837 528 152 528H16C7.16344 528 0 520.837 0 512Z",
    fill: "#22E06C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6406 478L88.6406 495L82.6406 495L82.6406 478L88.6406 478Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6406 489H97.6406V495H73.6406V489Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6406 444V469H82.6406V444H88.6406Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6405 441.014L97.8737 451.718L93.9227 456.233L85.6405 448.986L77.3583 456.233L73.4072 451.718L85.6405 441.014Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6406 449H70.6406V455H64.6406V477H106.641V455H100.641V449H112.641V483H58.6406V449Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M632 512V294C632 285.163 624.837 278 616 278H480C471.163 278 464 285.163 464 294V387C464 400.255 453.255 411 440 411H200C191.163 411 184 418.163 184 427V512C184 520.837 191.163 528 200 528H616C624.837 528 632 520.837 632 512Z",
    fill: "#22E06C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.641 310H573.641V355H528.641V310ZM534.641 316V349H567.641V316H534.641Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.641 320H563.641V338H557.641V326H545.641V320Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.009 324.875L544.766 343.118L540.523 338.875L558.766 320.632L563.009 324.875Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.641 343V359H540.641V365H518.641V343H524.641Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M648 512V294C648 285.163 655.163 278 664 278H795H1080C1088.84 278 1096 285.163 1096 294V379C1096 387.837 1088.84 395 1080 395H840C826.745 395 816 405.745 816 419V512C816 520.837 808.837 528 800 528H664C655.163 528 648 520.837 648 512Z",
    fill: "#22E06C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M734 490.667C729.049 490.667 724.301 488.7 720.801 485.199C717.3 481.699 715.333 476.951 715.333 472C715.333 467.049 717.3 462.301 720.801 458.801C724.301 455.3 729.049 453.333 734 453.333C738.951 453.333 743.699 455.3 747.199 458.801C750.7 462.301 752.667 467.049 752.667 472C752.667 476.951 750.7 481.699 747.199 485.199C743.699 488.7 738.951 490.667 734 490.667ZM752.747 457.04L756.533 453.253C755.333 451.893 754.133 450.667 752.773 449.493L748.987 453.333C744.853 449.973 739.653 448 734 448C727.635 448 721.53 450.529 717.029 455.029C712.529 459.53 710 465.635 710 472C710 478.365 712.529 484.47 717.029 488.971C721.53 493.471 727.635 496 734 496C747.333 496 758 485.253 758 472C758 466.347 756.027 461.147 752.747 457.04ZM731.333 474.667H736.667V458.667H731.333M742 440H726V445.333H742V440Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1280 512V294C1280 285.163 1272.84 278 1264 278H1128C1119.16 278 1112 285.163 1112 294V387C1112 400.255 1101.25 411 1088 411H848C839.163 411 832 418.163 832 427V512C832 520.837 839.163 528 848 528H1264C1272.84 528 1280 520.837 1280 512Z",
    fill: "#22E06C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1177.42 342.945C1181.49 338.303 1187.26 334.895 1193.64 334.895C1200.02 334.895 1205.79 338.303 1209.87 342.945C1213.95 347.591 1216.64 353.8 1216.64 360V363H1170.64V360C1170.64 353.8 1173.33 347.591 1177.42 342.945ZM1176.92 357H1210.36C1209.7 353.408 1207.91 349.814 1205.36 346.904C1202.08 343.176 1197.85 340.895 1193.64 340.895C1189.44 340.895 1185.2 343.176 1181.92 346.904C1179.37 349.814 1177.58 353.408 1176.92 357Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1194.17 318.79C1189.72 318.79 1186.12 322.394 1186.12 326.842C1186.12 331.291 1189.72 334.895 1194.17 334.895C1198.62 334.895 1202.22 331.291 1202.22 326.842C1202.22 322.394 1198.62 318.79 1194.17 318.79ZM1180.12 326.842C1180.12 319.08 1186.41 312.79 1194.17 312.79C1201.93 312.79 1208.22 319.08 1208.22 326.842C1208.22 334.605 1201.93 340.895 1194.17 340.895C1186.41 340.895 1180.12 334.605 1180.12 326.842Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 262,
    rx: 16,
    fill: "#22E06C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatItCanDoHm);
export default __webpack_public_path__ + "static/media/what_it_can_do_hm.cfb0801d1899df1c6f0214c82c74a8e4.svg";
export { ForwardRef as ReactComponent };